<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> لیست بج های سواد اساتید </template>
    <template #titleBtn>
      <BButton variant="success" to="/apps/literacy-badges/create">
        ایجاد بج جدید
      </BButton>
    </template>
    <CustomTable
      v-if="literacyBadgeList"
      :pageNumber="literacyBadgesFilters.pageNumber"
      :count="literacyBadgesFilters.count"
      :totalCount="totalCount"
      :tableItems="literacyBadgeList"
      :tableColumns="tableColumns"
      @changePage="changePage"
    >
      <template #imageUrl="data">
        <BImg
          width="50px"
          rounded
          height="auto"
          fluid
          :src="`${data.item.imageUrl}`"
        ></BImg>
      </template>

      <template #actions="data">
        <BButton
          :to="`/apps/literacy-badges/${data.item.id}`"
          variant="transparent"
          size="sm"
        >
          <FeatherIcon icon="EditIcon" size="23" class="text-info" />
        </BButton>
        <BButton
          variant="transparent"
          size="sm"
          @click="renderDeleteLiteracyBadgeConfirmation(data.item)"
        >
          <FeatherIcon icon="Trash2Icon" size="23" class="text-danger" />
        </BButton>
      </template>
    </CustomTable>
    <DeleteLiteracyBadgeConfirmationDialog
      :defaultLiteracyBadge="tempSelectedLiteracyBadge"
      @refetch="getAllBadges"
    ></DeleteLiteracyBadgeConfirmationDialog>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllBadges();
  },
  data() {
    return {
      isLoading: false,
      literacyBadgesFilters: {
        pageNumber: 1,
        count: 10,
      },
      literacyBadgeList: null,
      totalCount: null,
      tempSelectedLiteracyBadge: null,
      tableColumns: [
        {
          key: "id",
          label: "شناسه بج",
        },
        {
          key: "title",
          label: "عنوان بج",
        },
        {
          key: "userBasePricePercent",
          label: "نسبت پرداختی زبان آموز به قیمت پایه (به درصد)",
          formatter: (value) => `${value}%`,
        },
        {
          key: "masterBasePricePercent",
          label: "نسبت درآمد استاد به قیمت پایه (به درصد)",
          formatter: (value) => `${value}%`,
        },
        {
          key: "imageUrl",
          label: "تصویر بج",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    renderDeleteLiteracyBadgeConfirmation(selectedBadge) {
      this.tempSelectedLiteracyBadge = selectedBadge;
      this.$bvModal.show("delete-literacy-badge-confirmation-dialog");
    },
    async changePage(pageNumber) {
      this.literacyBadgesFilters.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
      await this.getAllBadges();
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          literacyBadgePage: pageNumber,
        },
      });
    },
    async getAllBadges() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllLiteracyBadges = new GetAllLiteracyBadges(_this);
        getAllLiteracyBadges.setRequestParam(_this.literacyBadgesFilters);
        await getAllLiteracyBadges.fetch((res) => {
          _this.literacyBadgeList = res.data.data;
          _this.totalCount = res.data.totalCount;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTable,
    DeleteLiteracyBadgeConfirmationDialog,
    BButton,
    BLink,
    BImg,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import DeleteLiteracyBadgeConfirmationDialog from "@/views/components/LiteracyBadges/DeleteLiteracyBadgeConfirmationDialog.vue";
import { BButton, BLink, BImg } from "bootstrap-vue";
import { GetAllLiteracyBadges } from "@/libs/Api/LiteracyBadge";
</script>
